import { render, staticRenderFns } from "./CommentOutline.vue?vue&type=template&id=5971ca44"
import script from "./CommentOutline.vue?vue&type=script&lang=js"
export * from "./CommentOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports